//@ts-check
import { myxchngApiClient } from '../../utils/RequestClient';
import RequestSearchParams from '../../utils/RequestSearchParams';

/**
 *
 * @param {object} params
 * @param {string} params.token
 * @param {string} params.org
 * @param {AbortSignal} [params.signal]
 * @returns {Promise<import('@action-types/xrApp').GetXrAppsResponse>}
 * @throws {import('@action-types/RequestError').RequestError<import('@action-types/ecApp').MyxchngApiErrorResponse>}
 */
const getXrAppBuilderApps = async ({ signal, token, org }) => {
  const search = new RequestSearchParams({ org });
  const headers = new Headers({ authorization: `Bearer ${token}` });
  const { jsonResponse } = await myxchngApiClient.fetch({
    endpoint: `/v2/ecapps${search}`,
    requestOptions: {
      signal,
      headers,
    },
  });
  return jsonResponse;
};

export default getXrAppBuilderApps;
